import { render, staticRenderFns } from "./storeCollectionDetail.vue?vue&type=template&id=68edfd9e&scoped=true"
import script from "./storeCollectionDetail.vue?vue&type=script&lang=js"
export * from "./storeCollectionDetail.vue?vue&type=script&lang=js"
import style0 from "./storeCollectionDetail.vue?vue&type=style&index=0&id=68edfd9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68edfd9e",
  null
  
)

export default component.exports